import { ChevronRight, Send, X } from 'lucide-react'
import React from 'react'
import { Button } from '../ui/button'
import { cn } from '../../lib/utils'
import { isMobile } from 'react-device-detect';

const Home = ({ chatConfigurationStyle, showHome, setShowHome, handleSendMessage, homeHeight, setIsOpen }) => {
  return (
    <div className={cn('bg-gradient-to-b from-primary to-primary/60 p-[26px] rounded-lg overflow-y-auto overflow-x-hidden',isMobile && "rounded-none")} style={{ height: homeHeight ? homeHeight : '632px' }}>
      <div className='flex justify-between items-center'>
        <div className='flex justify-start items-center gap-2'>
          <div className='w-[50px] h-[50px]'>
            <img className='object-contain w-full h-full' src={`${process.env.REACT_APP_S3_BASE_URL}/${chatConfigurationStyle?.profile}`} alt="Profile" />
          </div>
          <h2 className='text-lg font-semibold text-white'>{chatConfigurationStyle?.displayName}</h2>
        </div>
        <X onClick={() => setIsOpen(false)} className={cn('w-5 h-5 cursor-pointer hidden text-white',isMobile && "block")} />
      </div>
      <h2 className='text-xl font-semibold my-3 text-white'>{chatConfigurationStyle?.initialMessages}</h2>

      {/* FAQ List */}
      <div className='bg-white p-1.5 rounded-md my-5'>
        {chatConfigurationStyle?.faqs?.map((faq, index) => (
          <button
            key={index}
            className="w-full flex justify-between items-center p-2 rounded-md hover:bg-gray-100 text-[14px] font-[400] text-start"
            onClick={() => handleSendMessage(faq)}
          >
            {faq?.question} <ChevronRight size={16} />
          </button>
        ))}
      </div>

      {/* Chat Button */}
      <div onClick={() => setShowHome(false)} className='py-2 px-3 bg-white rounded-md flex items-center justify-between cursor-pointer'>
        <div className="flex items-center gap-2">
          <div className='w-[30px] h-[30px] rounded-full'>
            <img className='object-contain w-full h-full' src={`${process.env.REACT_APP_S3_BASE_URL}/${chatConfigurationStyle?.profile}`} alt="Profile" />
          </div>
          <div>
            <span className='text-[14px] font-[600]'>{chatConfigurationStyle?.displayName}</span>
            <span className='text-[13px] block'>Ask us anything</span>
          </div>
        </div>
        <Button size="icon" variant="ghost">
          <Send size={18} />
        </Button>
      </div>
    </div>
  )
}

export default Home